<template>
<div class="chapter">
<div class="inner_page">
<p class="copy-t1">The Monkey and the Maize</p>
<p class="copy-t2">An Allegorical Tale of Developing Leadership Skills in Business and in Life</p>
<p class="copys">© 2021 S. Mosby Marble</p>
<p class="copy">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.</p>
<p class="copy">Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. <a href="http://www.MorganJamesPublishing.com" target="_blank">www.MorganJamesPublishing.com</a></p>
<p class="copy">ISBN 9781631952609 paperback</p>
<p class="copyn">ISBN 9781631952616 eBook</p>
<p class="copyn">Library of Congress Control Number: 2020940585</p>
<p class="copy"><b>Cover and Interior Design by:</b></p>
<p class="copyn">Chris Treccani</p>
<p class="copyn"><a href="http://www.3dogcreative.net" target="_blank">www.3dogcreative.net</a></p>
<p class="copy"><b>Editor:</b> David Lambert</p>
<p class="copy"><b>Cover Image:</b> 588ku from <a href="http://www.pngtree.com" target="_blank">pngtree.com</a></p>
<p class="imagelogo"><img alt="image" src="images/logo.png"/></p>
<p class="copyc">Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.</p>
<p class="copyc">Get involved today! Visit<br/><a href="http://www.MorganJamesPublishing.com" target="_blank">MorganJamesPublishing.com/giving-back</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?5e300205